(function () {
  var SELECTOR = '[data-product-badge][data-metafield-badges], [data-product-single-badge][data-metafield-badges]';

  function parseBadges(el) {
    var data = el.getAttribute('data-metafield-badges');
    if (!data || data === '[]') return [];
    try {
      var parsed = JSON.parse(data);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function appendMetafieldBadges(container) {
    var badges = parseBadges(container);
    var existing = container.querySelectorAll('.t4s-badge-metafield');
    if (existing.length === badges.length && badges.length > 0) {
      var matches = true;
      existing.forEach(function (span, index) {
        if (!badges[index] || span.textContent !== badges[index].text) {
          matches = false;
        }
      });
      if (matches) return;
    }
    existing.forEach(function (span) {
      span.remove();
    });
    badges.forEach(function (badge) {
      if (!badge || !badge.text) return;
      var span = document.createElement('span');
      span.className = 't4s-badge-item t4s-badge-custom t4s-badge-metafield';
      if (badge.color) {
        span.style.backgroundColor = badge.color;
      }
      span.textContent = badge.text;
      container.appendChild(span);
    });
  }

  function initContainer(container) {
    if (container._mfBadgeObserving) return;
    container._mfBadgeObserving = true;

    var observer = new MutationObserver(function () {
      var badges = parseBadges(container);
      var existing = container.querySelectorAll('.t4s-badge-metafield');
      if (existing.length < badges.length) {
        appendMetafieldBadges(container);
      }
    });
    observer.observe(container, { childList: true });
    appendMetafieldBadges(container);
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll(SELECTOR).forEach(initContainer);
  }

  function scheduleInit(root) {
    initAll(root);
    setTimeout(function () {
      initAll(root);
    }, 100);
    setTimeout(function () {
      initAll(root);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit();
    });
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scheduleInit(e.target);
  });

  var mainContent = document.getElementById('MainContent') || document.body;
  var gridObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(SELECTOR)) {
            initContainer(node);
          } else {
            initAll(node);
          }
        }
      });
    });
  });
  gridObserver.observe(mainContent, { childList: true, subtree: true });
})();
